// import React, {useState} from "react";
// import Login from "./Login";
// import Register from "./Register";
// import "./Auth.css"; // Import the CSS for styling
// import { FaProjectDiagram } from "react-icons/fa";

// function AuthPage(){

// const [active,setActive]=useState(false);

// return(
// <div className="auth-wrapper">

// <div className={`container ${active ? "right-panel-active":""}`}>

// {/* Register */}
// <div className="form-container sign-up-container">
// <Register/>
// </div>

// {/* Login */}
// <div className="form-container sign-in-container">
// <Login/>
// </div>

// {/* Sliding Overlay */}
// <div className="overlay-container">
// <div className="overlay">

// <div className="overlay-panel overlay-left">
// <div className="brand-logo">

// </div>

// <h1>Welcome to PulseConnect</h1>

// <p>
// Secure communication infrastructure
// for modern applications
// </p>

// <button
// className="ghost-btn"
// onClick={()=>setActive(false)}
// >
// Login
// </button>

// </div>


// <div className="overlay-panel overlay-right">
// <div className="brand-logo">

// </div>

// <h1>PulseConnect</h1>

// <p>
// Unified platform for
// Email • SMS • Payment Gateway
// Integrations
// </p>

// <button
// className="ghost-btn"
// onClick={()=>setActive(true)}
// >
// Register
// </button>

// </div>

// </div>
// </div>

// </div>

// </div>
// )

// }

// export default AuthPage;


import React, { useState } from "react";
import Login from "./Login";
import Register from "./Register";
import "./Auth.css"; // Import the CSS for styling
import { FaProjectDiagram } from "react-icons/fa";
import brandLogo from "../../assets/Tapasyatech_trans.png"

function AuthPage() {
  const [active, setActive] = useState(false);

  return (
    <div className="auth-wrapper">
      <div className={`container ${active ? "right-panel-active" : ""}`}>
        
        {/* Register - Added switchToLogin prop */}
        <div className="form-container sign-up-container">
          <Register switchToLogin={() => setActive(false)} />
        </div>

        {/* Login */}
        <div className="form-container sign-in-container">
          <Login />
        </div>

        {/* Sliding Overlay */}
        <div className="overlay-container">
          <div className="overlay">
            <div className="overlay-panel overlay-left">
           
<div className="brand-logo-wrapper" style={{ marginBottom: "-60px", marginTop: "-150px",display: "flex", justifyContent: "center" }}>
            <img 
              src={brandLogo} 
              alt="PulseConnect Logo" 
              style={{ 
                maxWidth: "300px", 
                height: "auto", 
               
              }} 
            />
          </div>
              <h1>Welcome to PulseConnect</h1>
              <p>Secure communication infrastructure for modern applications</p>
              <button className="ghost-btn" onClick={() => setActive(false)}>
                Login
              </button>
            </div>

            <div className="overlay-panel overlay-right">
<div className="brand-logo-wrapper" style={{ marginBottom: "-60px", marginTop: "-230px",display: "flex", justifyContent: "center" }}>
            <img 
              src={brandLogo} 
              alt="PulseConnect Logo" 
              style={{ 
                maxWidth: "300px", 
                height: "auto", 
               
              }} 
            />
          </div>
              <h1 style={{ margin: "0 0 10px 0" }}>PulseConnect</h1> 
<p>Unified platform for Email • SMS • Payment Gateway Integrations</p>
              <button className="ghost-btn" onClick={() => setActive(true)}>
                Register
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default AuthPage;